import { useDirtyFormPrompt } from "../../hooks/form/useDirtyFormPrompt";

type DirtyFormPromptProps = {
  children: React.ReactNode;
};

export const DirtyFormPrompt: React.FC<DirtyFormPromptProps> = ({
  children,
}) => {
  useDirtyFormPrompt();
  return <>{children}</>;
};
